import { Injectable } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import localeNorwegian from "@angular/common/locales/nb";
import localeSwedish from "@angular/common/locales/sv";
import localeFr from "@angular/common/locales/fr";
import localeES from "@angular/common/locales/es";
import localePT from "@angular/common/locales/pt";
import localeEN from "@angular/common/locales/en";
import localeCS from "@angular/common/locales/cs";
import localeEL from "@angular/common/locales/el";
import localeDE from "@angular/common/locales/de";
import localeHU from "@angular/common/locales/hu";
import localeIT from "@angular/common/locales/it";
import localeNL from "@angular/common/locales/nl";
import localeRO from "@angular/common/locales/ro";
import localeSK from "@angular/common/locales/sk";
import localeTR from "@angular/common/locales/tr";
import localeFI from "@angular/common/locales/fi";
import localeDA from "@angular/common/locales/da";

@Injectable({ providedIn: "root" })
export class LocaleService {
  private _locale: string;

  set locale(value: string) {
    this._locale = value;
  }
  get locale(): string {
    return this._locale || "en-US";
  }

  registerCulture(culture: string) {
    if (!culture) {
      return;
    }
    this.locale = culture;
    // Register locale data since only the en-US locale data comes with Angular
    switch (culture) {
      case "nb-NO": {
        registerLocaleData(localeNorwegian);
        break;
      }
      case "sv-SE": {
        registerLocaleData(localeSwedish);
        break;
      }
      case "fr-FR": {
        registerLocaleData(localeFr);
        break;
      }
      case "es-ES": {
        registerLocaleData(localeES);
        break;
      }
      case "pt-PT": {
        registerLocaleData(localePT);
        break;
      }
      case "en-GB": {
        registerLocaleData(localeEN);
        break;
      }
      case "el-GR": {
        registerLocaleData(localeEL);
        break;
      }
      case "cs-CZ": {
        registerLocaleData(localeCS);
        break;
      }
      case "de-CH": {
        registerLocaleData(localeDE);
        break;
      }
      case "fr-BE": {
        registerLocaleData(localeFr);
        break;
      }
      case "fr-CH": {
        registerLocaleData(localeFr);
        break;
      }
      case "hu-HU": {
        registerLocaleData(localeHU);
        break;
      }
      case "it-CH": {
        registerLocaleData(localeIT);
        break;
      }
      case "nl-BE": {
        registerLocaleData(localeNL);
        break;
      }
      case "ro-RO": {
        registerLocaleData(localeRO);
        break;
      }
      case "sk-SK": {
        registerLocaleData(localeSK);
        break;
      }
      case "tr-TR": {
        registerLocaleData(localeTR);
        break;
      }
      case "fi-FI": {
        registerLocaleData(localeFI);
        break;
      }
      case "da-DK": {
        registerLocaleData(localeDA);
        break;
      }
      case "de-AT": {
        registerLocaleData(localeDE);
        break;
      }
      case "de-DE": {
        registerLocaleData(localeDE);
        break;
      }
      case "nl-NL": {
        registerLocaleData(localeNL);
        break;
      }
    }
  }
}
